import Random from "rung/src/random";
import { manhattanDistance } from "flatland/src/distance";
import { plotLine } from "flatland/src/line";
import Entity from "./entity";
import Glyphs from "../glyphs";
import Speed from "./speed";
import Mass from "./mass";
import Health from "./health";
import Equipment from "./equipment";
import Weapons from "./weapons";
import Armors from "./armors";
import Ammunition from "./ammunition";
import Statblock from "./statblock";
import Description from "./description";
import * as actions from "./actions";
import * as behaviour from "./behaviour";

const rng = new Random(Math.random);

class KoboldBeserkerSense {
  constructor() {
    this.chasing = false;
  }

  isEnemy() {
    return true;
  }

  shotFrom() {
    this.chasing = true;
  }

  bumpFrom(entity) {
    return true;
  }

  takeTurn(stage) {
    if (this.chasing) {
      behaviour.meleeCharge(this.owner, stage.player, stage);
    } else {
      if (stage.isVisible(this.owner.x, this.owner.y)) {
        this.chasing = true;
        // Spend a turn here...
      } else {
        behaviour.drunkenWalk(this.owner, stage);
      }
    }
  }
}

class KoboldSharpshooterSense {
  constructor() {
    this.chasing = false;
  }

  isEnemy() {
    return true;
  }

  shotFrom() {
    this.chasing = true;
  }

  bumpFrom(entity) {
    return true;
  }

  takeTurn(stage) {
    // See if the player is nearby
    if (stage.isVisible(this.owner.x, this.owner.y)) {
      console.log("sharpshooter can see player")

      console.log(this.owner.equipment)

      if (this.owner.equipment.quiver.ammunition.isEmpty()) {
        // Can’t do much if no ammo left
        // TODO: give these dog boys something else to do here
        console.log("quiver is empty")
        return;
      }

      // Try to get a line of sight
      const playerPos = {
        x: stage.player.x,
        y: stage.player.y
      }

      // TODO: would it be more interesting if they ocassionally tried
      // to fire through a crowd rather than checked line of sight?
      const [, ...targetTrail] = plotLine(this.owner, playerPos);
      let hasClearLos = true;

      // We don’t want to include the player here
      targetTrail.pop();

      for (const trail of targetTrail) {
        // TODO: sort this out with a better tile representation
        console.log(stage.isShotCovered(trail.x, trail.y))

        if (stage.isShotCovered(trail.x, trail.y)) {
          hasClearLos = false;
          break;
        }
      }

      if (hasClearLos) {
        console.log("hasClearLos")
        console.log(hasClearLos)
        console.log("fireAction")
        actions.fireAction(this.owner, playerPos, stage);
      }
    }
  }
}

class Kobolds {
  static beserker() {
    return new Entity(null, null, Glyphs.KoboldBeserker, "Kobold Beserker", {
      description: new Description("A scaly little lizard-rat humanoid in a fighting frenzy."),
      mass: new Mass(Mass.Small),
      speed: new Speed(12),
      health: new Health(12),
      sense: new KoboldBeserkerSense(),
      stats: new Statblock(9, 14, 9),
      equipment: new Equipment(rng.boolean() ? Weapons.flintSpear() : Weapons.wormtoothDagger())
    });
  }

  static sharpshooter() {
    return new Entity(null, null, Glyphs.KoboldSharpshooter, "Kobold Sharpshooter", {
      description: new Description("How the hell did he climb all the way out there?"),
      mass: new Mass(Mass.Small),
      speed: new Speed(3),
      health: new Health(12),
      sense: new KoboldSharpshooterSense(),
      stats: new Statblock(7, 15, 9),
      equipment: new Equipment(Weapons.blowgun(), Armors.leather(), [], Ammunition.needles(29))
    });
  }
}

export default Kobolds;
